module.exports = __webpack_public_path__ + "static/anga-iscrizione-cat-9E-materia3-f8bf434917ff8f6abd88369359f1a2f2.pdf";